export default {"src":"/_next/static/media/classLink.d7b838ab.svg","height":341,"width":341,"blurWidth":0,"blurHeight":0};